export const sceneTiltDeg = 20
export const defaultZoomDistance = 50